import styles from './gpt-definitions.module.scss';
import { useContext, useState } from 'react';
import { Col, Row } from 'reactstrap';

import { makeRequest } from '../requestUtils';
import { Divider, Icon, List, ListItemButton, ListItemIcon, ListItemText, MultiLineTextField, PrimaryButton, SecondaryButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';

import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../requestUtils';

/* eslint-disable-next-line */
export interface GPTDefinitionsProps {
  definitions: any;
  refresh: () => void;
}

export function GPTDefinitions(props: GPTDefinitionsProps) {
  const makeRequest= useMakeRequestHook();
  const [content, setContent] = useState<string>("");
  const [functionName, setFunctionName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const { t } = useTranslation();

  const handleNewDefinition = () => {
    const body = {
      content,
      description,
      functionName,
      id: selectedId,
      isBackup: false
    }
    makeRequest(`gpt/definitions`, 'PUT', body)
      .then(() => {
        props.refresh();
        console.log('Route created');
      });
  }
  const handleSaveAsBackup = () => {
    const body = {
      content,
      description,
      functionName,
      id: selectedId,
      isBackup: true
    }
    makeRequest(`gpt/definitions`, 'PUT', body)
      .then(() => {
        props.refresh();
        console.log('Route created');
      });
  }
  const handleNewRouteSelected = () => {
    setSelectedId(null);
    setFunctionName("");
    setDescription("");
    setContent("");
    setSelectedIndex(0);
  };
  const handleGetBackup = () => {
    makeRequest(`gpt/definitions/${selectedId}/backup`)
      .then((result) => {
        setSnackbarMessage({ content: t("standard.backupRetrieved"), type: "success" });
        setSelectedId(result.id);
        setDescription(result.description);
        setFunctionName(result.functionName);
        setContent(result.content);
      }).catch(ex => {
        setSnackbarMessage({ content: t("standard.noBackupFound"), type: "error" });
      });
  };

  return (
    <Row>
      <Col md={4} xl={3}>
        <List>
          <ListItemButton
            selected={selectedIndex === 0}
            onClick={handleNewRouteSelected}>
            <ListItemIcon className='d-none d-xxl-block'>
              <Icon className="material-icons-outlined d-flex align-items-center">post_add</Icon>
            </ListItemIcon>
            {t("gptDefinations.newFunction")}
          </ListItemButton>
          {props.definitions?.map((route: any, i: number) => {
            i++;
            const handleSelectUrl = () => {
              setSelectedId(route.id);
              setFunctionName(route.functionName);
              setDescription(route.description);
              setContent(route.content);
              setSelectedIndex(i);
            }
            return (
              <ListItemButton
                key={i}
                selected={selectedIndex === i}
                onClick={handleSelectUrl}>
                <ListItemIcon className='d-none d-xxl-block'>
                  <Icon className="material-icons-outlined d-flex align-items-center">article</Icon>
                </ListItemIcon>
                <ListItemText>
                  {route.functionName}
                </ListItemText>
              </ListItemButton>
            );
          })}
        </List>
      </Col>

      <Col md={8} xl={7}>
        <div className='mb-3'>
          {selectedId &&
            <PrimaryButton
              variant='contained'
              onClick={handleGetBackup}
              className='minButtonWidth'>
              {t("gptDefinations.getBackup")}
            </PrimaryButton>
          }
        </div>
        <div className='mb-3'>
          <TextField
            fullWidth
            value={functionName}
            label={t("gptDefinations.functionName")}
            onChange={(event: any) => setFunctionName(event.target.value)}
            placeholder="e.g GetCompanyFromCompanyName"
          />
        </div>
        <div className='mb-3'>
          <MultiLineTextField
            label={t("standard.shortDescription")}
            rows={10}
            fullWidth
            value={description}
            onChange={(event: any) => setDescription(event.target.value)}
            placeholder={String(t("gptDefinitions.shortDescriptionSoThatGptUnderstandsWhenToUseFunction"))}
          />
        </div>
        <div className='mb-3'>
          <MultiLineTextField
            label={t("gptDefinations.content")}
            fullWidth
            rows={30}
            value={content}
            onChange={(event: any) => setContent(event.target.value)}
            placeholder={String(t("gptDefinitions.informationGptRetrievesWhenFunctionIsCalled"))}
          />
        </div>
        <div className="d-flex mb-3">
          <PrimaryButton
            variant='contained'
            onClick={handleNewDefinition}
            className='minButtonWidth'>
            {t("gptDefinations.createNewFunction")}
          </PrimaryButton>
          {selectedId && <Divider orientation="vertical" variant="middle" flexItem className="mx-4" />}
          {selectedId &&
            <SecondaryButton
              variant='contained'
              onClick={handleSaveAsBackup}
              className='minButtonWidth'>
              {t("standard.saveAsBackup")}
            </SecondaryButton>}
        </div>
      </Col>
    </Row>
  );
}

export default GPTDefinitions;
